import { mobileMenu, faqManager, initFormHandler, initScrollAnimations, trackPageView, showNotification, config } from '../lib';

export function initHomePage(): void {
  console.log('Initializing home page');

  // Initialize shared utilities
  mobileMenu.init();
  faqManager.init();
  initScrollAnimations();
  trackPageView();

  // Initialize forms
  initFormHandler({
    formSelector: 'form:not(.newsletter-form)',
    pageName: config.pages.home
  });

  // Newsletter form
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = (document.querySelector('.newsletter-input') as HTMLInputElement)?.value;
      if (email) {
        const message = `🔔 *Newsletter Subscription Request*\n\nHello! I'd like to subscribe to your newsletter.\n\n📧 My email: ${email}\n\nPlease add me to your mailing list. 🙏`;
        const encoded = encodeURIComponent(message);
        const url = `${config.whatsappBaseUrl}?phone=${config.phoneNumber}&text=${encoded}`;
        window.open(url, '_blank');
        showNotification('Opening WhatsApp to complete subscription!', 'success');
      }
    });
  }
}

// Auto-initialize
if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', initHomePage);
}
